type AnalyticsEvent = {
  event: string;
  event_category?: string;
  event_label?: string;
  link_type?: string;
  link_location?: string;
  destination?: string;
};

type DataLayerWindow = Window & {
  dataLayer?: AnalyticsEvent[];
};

export const trackEvent = (eventData: AnalyticsEvent) => {
  if (typeof window === 'undefined') {
    return;
  }

  const dataLayer = (window as DataLayerWindow).dataLayer;

  if (!Array.isArray(dataLayer)) {
    return;
  }

  dataLayer.push(eventData);
};
